module.exports = __webpack_public_path__ + "img/56.50451479.webp";